/**
 * @author 阿怼
 * @date 2020-11-23 17:25
 */
import copy from './copy.js';
// 自定义指令
const directives = {
  copy
};
// 这种写法可以批量注册指令
export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  }
};




// WEBPACK FOOTER //
// ./src/libs/copy/index.js